import { DataService } from "@/services/data";
import { RouteObject } from "react-router-dom";
import { handle_error, handle_success } from "@/utils/wretch";
import { toast } from "sonner";

const ListViewRoute: RouteObject = {
    path: "list-views",
    children: [
        {
            path: "picklists",
            loader: async () => {
                try {
                    const response = await DataService.client.url("/crm/app/list-views/picklists/").get().json();

                    return response;
                } catch (error) {
                    console.error("Error loading picklists:", error);
                    return { users: [], roles: [] };
                }
            }
        },
        {
            path: ":id/shares",
            loader: async ({ params }) => {
                try {
                    const response = await DataService.client.url(`/crm/app/list-views/${params.id}/shares/`).get().json();

                    return response;
                } catch (error) {
                    console.error("Error loading shares:", error);
                    return [];
                }
            }
        },
        {
            path: ":id/share",
            action: async ({ params, request }) => {
                try {
                    const data = await request.json();
                    const response = await DataService.client.url(`/crm/app/list-views/${params.id}/share/`).post(data).json();

                    toast.success("Sharing settings updated successfully");
                    return handle_success(response);
                } catch (error) {
                    return handle_error(error);
                }
            }
        },
        {
            path: ":id/unshare",
            action: async ({ params }) => {
                try {
                    const response = await DataService.client.url(`/crm/app/list-views/${params.id}/unshare/`).delete().json();

                    toast.success("Sharing removed successfully");
                    return handle_success(response);
                } catch (error) {
                    return handle_error(error);
                }
            }
        }
    ]
};

export default ListViewRoute;
